import React, { useEffect, useState,Fragment, useReducer } from 'react'
import { Button, Col, Container, Form, FormControl, InputGroup, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import buscarReducer, { initialStateDisabled } from './storeBuscar/buscar-reducers'
import { INIT, RESET, SET_DIAS, SET_DISABLED, SET_TIPO_GESTION } from './storeBuscar/types'
import {useFormik} from 'formik'
import { restarMeses, validaNumeros } from '../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { limpiarCasos, obtenerCasos } from '../../store/actions/area-busqueda-ingreso-recuperos-cuota-action'
import { validationSchemas } from '../../common/validation-Schemas-area-busqueda'
import { useLocation, useNavigate } from 'react-router-dom'

const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}
const resetValues={tipofecha:'',dias:'',idcaso:'',patenteAS:'',patenteImp:'',siniestro:'',fechahasta:'',fechadesde:'',diasVencimiento:''}

const BuscarCasos = () => {  
    const history = useNavigate()
    const [loading, setLoading]=useState(false)
    const [myValues, setMyValues]=useState(resetValues)
    const [noFechas, setNoFechas]=useState(true)

    const [selected, setSelected]=useState('')
    const [dias, setDias]=useState('')
  
    const [isDias, setIsDias]=useState(false)
  
    const [isFechas, setIsfechas]=useState(true)
    const {rutUsuario, rutOrganizacion}=Auth.currentUser()
    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosIngresoRecuperoReducer)
    const {cfg_form87, fechas, comboTipoFecha, consultaCasos} = data_areaBuscar
  
    const [stateBuscar, dispatchBuscar]=useReducer(buscarReducer, initialStateDisabled)
    const dispatch = useDispatch()
    const { state } = useLocation()
    let querState = state?.queryState && state?.queryState
     
    const handleRadio=(e)=>{
      setSelected(e.target.id)
      if(e.target.id==='tipogestion'){
       
        dispatchBuscar({type:RESET})
        dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:e.target.id}})
      }else{

        dispatchBuscar({type:RESET})
        dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:e.target.id}})
      }
      setMyValues(resetValues)
      setIsfechas(false)
      
      setIsDias(false)
    }

  const handleLimpliar=()=>{
    setSelected('')
    setIsfechas(true)
    dispatchBuscar({type:INIT})
    dispatch(limpiarCasos())
    setMyValues(resetValues)
    querState=null
    
    setIsDias(false)
    if (fechas) {
      setMyValues({...resetValues, fechahasta:hoy(), fechadesde:restarMeses(parseInt(fechas.fechas['valorParametro']))})
    }
  }
  useEffect(()=>{
    dispatchBuscar({type:INIT})
  },[])

  useEffect(()=>{   
    if (querState) {
      let resultado={}
      let valores = Object.values(querState); 
      let myKeys = Object.keys(querState); 
      for(let i=0; i< valores.length; i++){
        if(valores[i]!=='' && myKeys[i]!=='rutcia' && myKeys[i]!=='rutusr' ){
          resultado[myKeys[i]]=valores[i]
        }
      }      
      let valoresR = Object.values(resultado); 
      let myKeysR = Object.keys(resultado); 
      let filter={...resetValues}

      for(let i=0; i< valoresR.length; i++){
        
        if(Object.entries(resultado).length===1 && myKeysR[i]!=='tipogestion'){
              setNoFechas(false)
              dispatchBuscar({type:RESET})
              dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:myKeysR[i]}})
              setMyValues({...resetValues,[myKeysR[i]]:valoresR[i], fechadesde:''})
        } else {
          if (myKeysR[i]==='tipogestion') {
            setNoFechas(false)
            dispatchBuscar({type:RESET})
            dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:myKeysR[i]}})
            for(let j=0; j< Object.entries(resultado).length; j++){
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          
          } else {
            setNoFechas(false)
            for(let j=0; j< Object.entries(resultado).length; j++){
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          }
        }
      
      }
      querState['rutcia'] = rutOrganizacion && rutOrganizacion
      querState['rutusr'] =rutUsuario && rutUsuario
      let query1 = Buffer.from(JSON.stringify(querState)).toString('base64')
      //console.log("filtro:", query1);
      dispatch(obtenerCasos(query1))     
    }
 
  setIsfechas(false)
    querState = null
    history('/area-ingreso-recuperos-cuota')
  },[state])
  useEffect(()=>{
    if(fechas && querState!==null && noFechas){
    setMyValues({...myValues, fechahasta:hoy(), fechadesde:restarMeses(fechas && parseInt(fechas.fechas['valorParametro']))})
  }
  
   
  },[fechas])
  const formik = useFormik({
    initialValues: {
      "rutcia": '',
      "rutusr":'',
      "idcaso": '',
      "siniestro":'',
      "patenteAS": '',
      "patenteImp": '',
      "fechadesde": '',
      "fechahasta": '', 
      "tipofecha": '', 
      "diasVencimiento": '', 
      "dias": '',          
    },
    validationSchema: validationSchemas(isFechas, isDias,selected),
    onSubmit: (formData) => {
      setLoading(true)
        const dataForm = {
            ...formData
        }

      dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
      dataForm['rutusr'] = rutUsuario && rutUsuario             
      let query = Buffer.from(JSON.stringify(dataForm)).toString('base64')
      dispatch(limpiarCasos())            
      dispatch(obtenerCasos(query)) 
      .then(()=>setLoading(false))
      localStorage.setItem('filtrosAreaIngresoCuotas', JSON.stringify(dataForm))          
    }
})
useEffect(()=>{
  //console.log(consultaCasos && consultaCasos, "respuesta casos")
},[consultaCasos])
  return (
    <>
 <style type='text/css'>
        {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    
    `}
    </style>
      <LoadingComponent show={loading}/>
      <Form onSubmit={formik.handleSubmit}>
          <Container>
            <Container>            
              {true ? (
                <div >                  
                  <Row >                 
                    <Col>
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-siniestro']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-siniestro']: 'Siniestro' }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select' id='siniestro' onChange={e=>handleRadio(e)} checked={stateBuscar.siniestro.disabled}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.siniestro.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)                                                    
                            setMyValues({...myValues,siniestro:e.target.value})
                          }}
                          value={formik.values.siniestro=myValues.siniestro}
                          name='siniestro'
                          error={formik.values.error}
                        />
                    </InputGroup>
                    {formik.errors.siniestro ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.siniestro}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-patenteas']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-patenteas']: 'Placa Asegurado' }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select'
                             id='patenteAS' checked={stateBuscar.patenteAS.disabled}
                             onChange={e=>handleRadio(e)} />
                        <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patenteAS.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              setMyValues({...myValues,patenteAS:e.target.value})
                              
                            }}
                            value={formik.values.patenteAS=myValues.patenteAS}
                            name='patenteAS'
                            error={formik.values.error}
                        />                         
                      </InputGroup>
                      {formik.errors.patenteAS ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.patenteAS}
                      </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col >
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-patenteimp']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-patenteimp']: 'Placa Implicado' }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select'
                             id='patenteImp' checked={stateBuscar.patenteImp.disabled}
                             onChange={e=>handleRadio(e)} />
                        <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patenteImp.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              setMyValues({...myValues,patenteImp:e.target.value})
                              
                            }}
                            value={formik.values.patenteImp=myValues.patenteImp}
                            name='patenteImp'
                            error={formik.values.error}
                        />                         
                      </InputGroup>
                      {formik.errors.patenteImp ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.patenteImp}
                      </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col >
                      <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-idcaso']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-idcaso']: 'ID Caso' }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input"
                         name='select' id='idcaso' 
                         checked={stateBuscar.idcaso.disabled}
                         onChange={e=>handleRadio(e)}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.idcaso.disabled}
                          onKeyDown={validaNumeros}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            
                            setMyValues({...myValues, idcaso: e.target.value})
                          }}
                          value={formik.values.idcaso=myValues.idcaso}
                          name='idcaso'
                          error={formik.values.error}
                      
                        />
                        </InputGroup>
                        {formik.errors.idcaso ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.idcaso}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>                                    
                  </Row>
                  <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                  
                <Row >
                <Col md='3' >
                   <Form.Label  className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                   {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-criteriofec']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-criteriofec']: 'Criterio Fecha' }
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.tipofecha.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tipofecha:e.target.value})
                       
                      }}
                      value={formik.values.tipofecha=myValues.tipofecha}
                      name='tipofecha'
                      error={formik.values.error} 
                   >
                   <option value={''}>Seleccione...</option>
                        {comboTipoFecha &&
                          comboTipoFecha.comboTipoFecha?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                   {formik.errors.tipofecha ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipofecha}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col> 
                 <Col md='3'>
                   <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                   {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-fechadesde']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-fechadesde']: 'Fecha Desde' }
                   </Form.Label>{' '}
                   <br />
                   
                     <Form.Control type='date'disabled={!stateBuscar.fechadesde.disabled}
                     name='fechadesde'
                     value={formik.values.fechadesde=myValues.fechadesde}
                     onChange={(e)=>{
                       formik.handleChange(e)
                       setMyValues({...myValues,fechadesde:e.target.value})                      
                      }
                     }
                     ></Form.Control>                
                 </Col>
                 <Col md='3' >
                   <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-fechahasta']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-fechahasta']: 'Fecha Hasta' }
                   </Form.Label>{' '}
                   <br />
                   <Form.Control type='date'  disabled={!stateBuscar.fechahasta.disabled}
                      name='fechahasta'
                      value={formik.values.fechahasta=myValues.fechahasta}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,fechahasta:e.target.value})
                        
                      }
                      }
                   ></Form.Control>
                 </Col>         
                 <Col >
                      <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-filtro-diasVencimiento']) ? cfg_form87.cfg_form87['areaingresorecuperos-filtro-diasVencimiento']: 'Días Vencimiento' }
                      </Form.Label>{' '}
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input"
                         name='select' id='diasVencimiento' 
                         checked={stateBuscar.diasVencimiento.disabled}
                         onChange={e=>handleRadio(e)}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.diasVencimiento.disabled}
                          onKeyDown={validaNumeros}
                          onChange={(e)=>{
                            formik.handleChange(e)                            
                            setMyValues({...myValues, diasVencimiento: e.target.value})
                          }}
                          value={formik.values.diasVencimiento=myValues.diasVencimiento}
                          name='diasVencimiento'
                          error={formik.values.error}
                      
                        />
                        </InputGroup>
                        {formik.errors.diasVencimiento ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.diasVencimiento}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                  </Col>                                 
               </Row>
               <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                  <Row className='mt-2'>                        
                      <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-boton-limpiar']) ?cfg_form87.cfg_form87["areaingresorecuperos-boton-limpiar"] : 'Limpiar'}
                        </Button>
                        <Button className='m-2' variant='buscar' type='onSubmit' >
                        {(cfg_form87 && cfg_form87.cfg_form87 && cfg_form87.cfg_form87['areaingresorecuperos-boton-buscar']) ?cfg_form87.cfg_form87["areaingresorecuperos-boton-buscar"] : 'Buscar'}
                        </Button>
                    </Col>
                  </Row>
                </div>
              ) : null}
            </Container>
          </Container>       
     </Form>    
    </>
  )
}

export default BuscarCasos
